module.exports = __webpack_public_path__ + "img/b_4.5984e69e.png";